<template>
  <div class="message-screen-list" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
        <div class="group-right">
          <el-button v-if="multipleSelection.length" type="primary" @click="screenContorl(1)" size="small" round>一键开屏</el-button>
          <el-button v-if="multipleSelection.length" type="info"  @click="screenContorl(0)" size="small" round>一键关屏</el-button>
          <el-tooltip class="refresh-item" effect="dark" content="刷新列表数据" placement="bottom">
            <el-button icon="el-icon-refresh"  @click="getTableData(pageInfo.page)" size="small" circle style="margin-left: 20px;"></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        :row-key="getRowKey"
        @selection-change="handleSelectionChange"
        stripe>
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column prop="name" label="屏幕名称" min-width="160"></el-table-column>
        <el-table-column prop="number" label="屏幕编号" width="160"></el-table-column>
        <el-table-column prop="area_code" label="区号(area_code)" min-width="200"></el-table-column>
        <el-table-column prop="lamp_name" label="所属路灯" width="180"> </el-table-column>
        <el-table-column prop="screen_type" label="厂家" width="80">
          <template slot-scope="scope">
            {{ screenType[scope.row.screen_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="ste" label="屏幕状态" width="120">
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steType[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pattern" label="设备模式" width="120">
          <template slot-scope="scope">
            <span>{{ patternType[scope.row.pattern] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="添加时间" width="140">
          <template slot-scope="scope">
            <span>{{ $commonJs.formatDate(parseInt(scope.row.created_at)*1000) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="编辑" fixed="right" width="120">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        ref="editForm" 
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="屏幕名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="屏幕编号" prop="number">
            <el-input v-model="editOne.number" :disabled="editType === 'create' ? false : true"></el-input>
          </el-form-item>
          <el-form-item label="所属区号" prop="area_code">
            <el-input v-model="editOne.area_code"></el-input>
          </el-form-item>

          <el-form-item label="屏幕厂家" prop="screen_type" v-if="editType === 'create'">
            <el-select
              placeholder="请选择屏幕厂家"
              v-model="editOne.screen_type"
              style="width: 100%"
            >
              <el-option label="仰邦" :value="0"></el-option>
              <el-option label="熙讯" :value="1"></el-option>
              <el-option label="卡莱特" :value="3"></el-option>
              <el-option label="诺瓦" :value="4"></el-option>
            </el-select>
          </el-form-item>
   
          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备模式" prop="pattern">
            <el-select
              placeholder="请选择设备模式"
              v-model="editOne.pattern"
              style="width: 100%"
            >
              <el-option label="公网" :value="0"></el-option>
              <el-option label="内网" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备地址" prop="device_address" v-if="editOne.pattern">
            <el-input v-model="editOne.device_address"></el-input>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList"
import screenApi from "@/api/message/screenList"
export default {
  data() {
    return {
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      screenType: ['仰邦','熙讯','','卡莱特','诺瓦'],
      patternType: ["公网", "内网"],
      loading: false,
      dialogVisible: false,
      lampList: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        number: [{ required: true, message: "请输入屏幕编号", trigger: "blur" }],
        area_code: [{ required: true, message: "请输入屏幕area_code(仰邦获取)", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        area_code: '',
        lamp_id: '',
        screen_type: 0,
        pattern: '',
        device_address: '',
      },
      multipleSelection: [],
      manualChange: false
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      screenApi.screenList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          area_code: '',
          lamp_id: '',
          screen_type: 0,
          pattern: '',
          device_address: '',
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          area_code: index.area_code,
          lamp_id: index.lamp_id,
          screen_type: index.screen_type,
          pattern: index.pattern,
          device_address: index.device_address
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },
    createItem() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          screenApi.screenAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    updateItem() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          screenApi.screenEdit(this.editOne.id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    getLampList() { // 获取灯组列表
      lightListApi.lightList({
        // lamp_protocol: 3,
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          screenApi.screenDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    getRowKey (row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    screenContorl(type){ //查询所选中的设备
      let selVal = this.multipleSelection
      if(selVal.length<1){
        this.$message.error('请选择选择屏幕');
      }
      let mulVal= '';
      for(let i=0; i<selVal.length; i++){
        mulVal=mulVal+selVal[i].id+','
      }
      mulVal=mulVal.slice(0,mulVal.length-1)
      screenApi.screenContorl({ screenId: mulVal,type:type }).then((res) => {
        // console.log('screenList',res)
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.getTableData(this.pageInfo.page)
        } else {
          this.$message.error(res.msg)
        }
      });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.message-screen-list{
  width: 100%;
  .form-info{
    padding-left:10px;
    .el-form-item__label{
      width:85px;
    }
  }
}

</style> 